import React, { createContext, useContext } from 'react';
import { bool, func, node, shape } from 'prop-types';
const Context = /*#__PURE__*/createContext(false);

const DropdownContext = ({
  children,
  value
}) => /*#__PURE__*/React.createElement(Context.Provider, {
  value: value
}, children);

export const useDropdownContext = () => useContext(Context);
process.env.NODE_ENV !== "production" ? DropdownContext.propTypes = {
  children: node,
  value: shape({
    isOpen: bool,
    setIsOpen: func,
    pointing: bool,
    handleOnChange: func,
    handleOnClick: func
  })
} : void 0;
export default DropdownContext;